/**
 * Gives color strings based on subtest subject (displayName)
 * @param {string} subject English, Math, Reading, Science, or other (displayName)
 * @param {boolean} hexQ If should return hex, true, else returns theme names like 'warning' or 'primary'
 * @returns {string} a hex or color theme name
 */
export default function assessmentColors(subject, hexQ) {

  const colorsBySubtestType = {
    English: '#5555555',
    Math: '#f86c6b',
    Reading: '#20a8d8',
    Science: '#4dbd74',
  }

  const fallbackColor = '#ffc107'

  const themeColors = {
    English: 'english',
    Math: 'danger',
    Reading: 'primary',
    Science: 'success',
  }

  const fallbackThemeColor = 'english'

  if (hexQ) {
    if (colorsBySubtestType[subject]) {
      return colorsBySubtestType[subject]
    } else {
      return fallbackColor
    }
  } else {
    if (themeColors[subject]) {
      return themeColors[subject]
    } else {
      return fallbackThemeColor
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentColors.js